import * as React from 'react';
import { withStyles, createStyles, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Quiz from '../Quiz/Quiz';

const jss = (theme: Theme) => createStyles({
    title: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        padding: theme.spacing.unit * 2,
    },
    content: {
        padding: theme.spacing.unit * 3,
    },
    actions: {
        padding: theme.spacing.unit,
    },
});

interface Props {
    quiz: Bee.Quiz;
    open: boolean;
    onClose: () => void;
    onSubmit: () => void;
    edit?: boolean;
    match: {
        path: string;
        params: {};
    };
    location: { hash: string };
    classes: {
        title: string;
        content: string;
        actions: string;
    };
}

class QuizPreview extends React.Component<Props, {}> {
  	render() {
        const { classes } = this.props;
        
        return (
            <Dialog open={this.props.open} onClose={this.props.onClose} fullWidth>
                <DialogTitle className={classes.title} disableTypography>
                    <Typography variant="h6" color="inherit">{`Preview And ${this.props.edit ? 'Save' : 'Publish'} Quiz`}</Typography>    
                </DialogTitle>
                <DialogContent className={classes.content}>
                    <Quiz
                        getQuiz={() => new Promise((resolve => resolve(this.props.quiz)))}
                        getParticipate={() => new Promise(resolve => resolve({ count: 0 }))}
                        onSubmit={() => null}
                        match={{
                            ...this.props.match,
                            params: {
                                ...this.props.match.params,
                                quizId: this.props.quiz.id,
                            },
                        }}
                        history={{
                            push: () => null,
                        }}
                        location={this.props.location}
                    />
                </DialogContent>
                <Divider />
                <DialogActions className={classes.actions}>
                    <Button color="primary" variant="outlined" onClick={this.props.onClose}>Cancel</Button>
                    <Button color="primary" variant="contained" onClick={this.props.onSubmit}>{this.props.edit ? 'SAVE' : 'CREATE'}</Button>
                </DialogActions>
            </Dialog>
        )
	}
}

export default withStyles(jss)(QuizPreview);



// WEBPACK FOOTER //
// ./src/components/Admin/QuizPreview.tsx